import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalstorageService {
  constructor() {}

  setItem(key: string, value: string) {
    localStorage.setItem(key, value);
    this.storageItemSet.next({ key, value });
  }

  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  storageItemSet: BehaviorSubject<{ key?: string; value?: string }> = new BehaviorSubject({});
  storageItemSetSource = this.storageItemSet.asObservable();
}
